import { RoutingRuleTriggerType } from '@mews-commander/data-access';
import { RoutingRuleListTableRowData } from '../types';

interface FilterTableDataParams {
    name?: string;
    timings?: RoutingRuleTriggerType[];
    company?: string | null;
    travelAgency?: string | null;
}

export const filterRoutingRuleTableRow = (params: FilterTableDataParams) => (row: RoutingRuleListTableRowData) => {
    if (!Object.keys(params).length) {
        return true;
    }

    const { name, timings, company, travelAgency } = params;

    if (name && !row.name?.includes(name)) {
        return false;
    }

    if (timings && !timings.includes(row.timing)) {
        return false;
    }

    if (company && !row.conditions.companies.some(({ id }) => id === company)) {
        return false;
    }

    if (travelAgency && !row.conditions.travelAgencies.some(({ id }) => id === travelAgency)) {
        return false;
    }

    return true;
};

export const filterRoutingRuleTableRowByGlobalSearch = (searchQuery: string) => (row: RoutingRuleListTableRowData) => {
    const match = (value: string | undefined | null) =>
        value?.toLocaleLowerCase().includes(searchQuery.toLocaleLowerCase());

    if (match(row.name)) {
        return true;
    }

    if ([...row.conditions.companies, ...row.conditions.travelAgencies].some(({ name }) => match(name))) {
        return true;
    }

    if (row.services.some(({ serviceName }) => match(serviceName))) {
        return true;
    }

    return false;
};
